import PaymentListTable from "./table";

const PaymentTransactions = () => {
  return <PaymentListTable />;
};

export default PaymentTransactions;
